import * as yup from 'yup';
import { phoneRegExp, documentRegExp, postalCodeRegExp } from '../../../../../helpers/regex';

export const businessInfoValidations = yup.object().shape({
  establishmentTypes: yup
    .array()
    .min(1, 'O tipo do negócio é obrigatório')
    .required('O tipo do negócio é obrigatório'),
  establishmentName: yup
    .string()
    .required('O nome do estabelecimento é obrigatório')
    .nullable(),
  documentId: yup
    .string()
    .matches(documentRegExp, {
      message: 'O CNPJ precisa ser válido',
      excludeEmptyString: true
    })
    .nullable(),
  phone: yup
    .string()
    .matches(phoneRegExp, {
      message: 'O telefone precisa ser válido',
      excludeEmptyString: true
    })
    .nullable(),
  email: yup
    .string()
    .email('O e-mail precisa ser válido')
    .nullable(),
  postalCode: yup
    .string()
    .matches(postalCodeRegExp, {
      message: 'O CEP precisa ser válido',
      excludeEmptyString: true
    })
    .nullable(),
  street: yup
    .string()
    .required('O endereço é obrigatório')
    .nullable(),
  number: yup
    .string()
    .nullable(),
  complement: yup
    .string()
    .nullable(),
  district: yup
    .string()
    .required('O bairro é obrigatório')
    .nullable(),
  city: yup
    .string()
    .required('A cidade é obrigatória')
    .nullable(),
  state: yup
    .string()
    .required('O estado (UF) é obrigatório')
    .min(2, 'O estado (UF) não pode ter menos que 2 caracteres')
    .nullable(),
  vacanciesMarks: yup
    .string()
    .required('O total de ocupação do pátio é obrigatório')
    .nullable()
});